/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalculationTypeCountResource } from './calculationTypeCountResource';
import { CalculationsCounts200ResponseMeta } from './calculationsCounts200ResponseMeta';


export interface CalculationsCounts200Response { 
    data: Array<CalculationTypeCountResource>;
    meta: CalculationsCounts200ResponseMeta;
}

